import React from 'react';
import StyledText from 'components/Helpers/StyledText/StyledText';

const Rubrik = props => {
  const { type, value } = props;
  const lctype = type.toLowerCase();
  const style = require('./Rubrik.scss');
  switch (lctype) {

    case 'rubrikmager':
      return (
        <h3 className={style.rubrikmager}>
          <StyledText>{value}</StyledText>
        </h3>
      );

    case 'rubrik2':
      return (
        <h2 className={style.rubrik2}>
          <StyledText>{value}</StyledText>
        </h2>
      );
    case 'rubrik3':
      return (
        <h3 className={style.rubrik3}>
          <StyledText>{value}</StyledText>
        </h3>
      );
    case 'rubrik4':
    return (
      <h4 className={style.rubrik4}>
        <StyledText>{value}</StyledText>
      </h4>
    );
    case 'mellanrubrik':
      return (
        <h4 className={style.mellanrubrik}>
          <StyledText>{value}</StyledText>
        </h4>
      );
    case 'rubrik5':
      return (
        <h4 className={style.rubrik5}>
          <StyledText>{value}</StyledText>
        </h4>
      );
    case 'rubrikxl':
      return (
        <h1 className={style.rubrikxl}>
          <StyledText>{value}</StyledText>
        </h1>
      );
      case 'rubrikneg':
        return (
          <h1 className={style.rubrikneg}>
            <StyledText>{value}</StyledText>
          </h1>
        );

    default:
      return (
        <h1 className={style.rubrik}>
          <StyledText>{value}</StyledText>
        </h1>
      );
  }
};

export default Rubrik;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Rubrik/Rubrik.js
 **/